const initialState= []




export default function customers(state = initialState, action) {
 if (action.type === 'LOAD_CUSTOMERS') {
      return        action.customers
  }

  return state;
}
